export default "__VITE_ASSET__BGwE3wys__"